import React from 'react';

import {useClientDetailsStore} from './ClientDetailsStore';
import Header from './Header';
import Tabs from './Tabs';
import Switch from './Switch';

export function ClientDetailsView() {
  const {state, dispatch} = useClientDetailsStore();

  React.useEffect(() => {
    dispatch({type: 'FETCH_DATA'});
  }, []);

  return state.client.loading ?
    <div className="loading-overlay"/> :
    <>
      <Header/>
      <Tabs/>
      <Switch/>
    </>;
}

export default ClientDetailsView;
